module.exports = __webpack_public_path__ + "images/safari1.jpg?de09a8c41b86ac38c579ba717d537703";